import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'

const SvgBarChart03 = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M6 20V4m12 16v-4m-6 4V10"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgBarChart03)
export default ForwardRef
